// 作品頁／草圖頁「影片與互動」iframe 的 allow 清單（WorkRecord.vue 的兩個 media iframe 都用這支）。
// 實驗室的執行頁（lab.cheyuwu.com/run/<slug>/?embed=1）多給 loopback-network（2026-10-05）：
// 舊的 Leap Motion 作品（200602-fish-race-leap-motion、210812-3d-hamilton-leapmotion…）透過本機橋接 ws://127.0.0.1:6437 又能玩了，
// 但 Chrome 只讓跨網域的 iframe 連本機迴路位址，條件是 iframe 帶 allow="loopback-network"（Chrome 154 實測；權限詢問會出現在官網這一頁）。
// 只給實驗室：其他嵌入（YouTube、OpenProcessing…）照舊三項，不多開權限。沒用到本機橋接的作品不會跳任何詢問。
export const MEDIA_ALLOW = 'fullscreen; encrypted-media; picture-in-picture'
export const LAB_ORIGIN = 'https://lab.cheyuwu.com'
export const isLabEmbed = src => typeof src === 'string' && src.startsWith(LAB_ORIGIN + '/')
export const mediaAllow = src => (isLabEmbed(src) ? MEDIA_ALLOW + '; loopback-network' : MEDIA_ALLOW)
